import type {
  StatusLabels,
  AnswerDto,
  QuestionDto,
  VoteValues,
} from '@plugins/faq-lib/types';
import {
  CreateComment,
  UpdateComment,
} from '@plugins/shared/types/post/response';
import { SortType } from '@plugins/shared/types/sort';

export class LoadAnswers {
  static readonly type = '[Answer] Load answers';
  constructor(
    public question: QuestionDto,
    public resetSort: boolean,
    public skip = 0,
    public take?: number,
  ) {}
}

export class LoadMoreAnswers {
  static readonly type = '[Answer] Load more answers';
  constructor(public question: QuestionDto) {}
}

export class AnswersLoaded {
  static readonly type = '[Answer] Answers loaded';
  constructor(
    public answers: AnswerDto[],
    public total: number,
  ) {}
}

export class CreateAnswer {
  static readonly type = '[Answer] Create new answer';
  constructor(
    public answer: CreateComment,
    public questionId: string,
  ) {}
}

export class UpdateAnswer {
  static readonly type = '[Answer] Update answer';
  constructor(public answer: UpdateComment) {}
}

export class DeleteAnswer {
  static readonly type = '[Answer] Delete answer';
  constructor(public answerId: string) {}
}

export class ChangeAcceptAnswer {
  static readonly type = '[Answer] Change acception of answer';
  constructor(
    public answerId: string,
    public questionStatus: StatusLabels,
  ) {}
}

export class ChangeAnswerVote {
  static readonly type = '[Answer] Change answer vote';
  constructor(
    public answerId: string,
    public voted: VoteValues,
    public vote: Exclude<VoteValues, 0>,
    public questionStatus: StatusLabels,
  ) {}
}

export class ChangeAnswersSort {
  static readonly type = '[Answer] Change answers sort';
  constructor(
    public sort: SortType,
    public question: QuestionDto,
    public skip = 0,
    public take?: number,
  ) {}
}

export class AnswerSubscribe {
  static readonly type = '[Answer] Subscribe';
  constructor(public answerId: string) {}
}

export class AnswerUnsubscribe {
  static readonly type = '[Answer] Unsubscribe';
  constructor(public answerId: string) {}
}
